import Cookies from "js-cookie"
import store from "@/store"
const TokenKey = "_token"

export function getToken() {
  return Cookies.get(TokenKey)
  // return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
  // return sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(TokenKey)
  Cookies.remove("ct_sso")
  return true
  // return sessionStorage.removeItem(TokenKey)
}
// 判断菜单按钮显示
export function checkBtnAuth(code) {
  return store.state.user.btnAuth.includes(code)
}
